import { accessRole } from "../../../../helpers/access_role"
import ErrorAccess from "../../../../components/Error/Content/Access"
import IndexComponent from "./Components/IndexComponent"

const RouteView = (props) => {
   return accessRole('read') ? <IndexComponent /> : <ErrorAccess />
}
export default RouteView